export default __webpack_public_path__ + "static/img/exhib-04.8115c49.png";